<div class="wrap">
  <div class="info">
    <span class="title">{{ 'pages.user-receipts.summary.title.' + data.transactionType | translate }}</span>
    <span class="dates">{{ data.created_at | date }}</span>
  </div>
  <div class="amount">
    <span>{{ data.total | localizeCurrency }}</span>
  </div>
  <div class="button">
    <span class="icon-caret-right"></span>
  </div>
</div>